const RISKY_EXTENSIONS = new Set([
  'exe', 'msi', 'com', 'scr', 'pif', 'cpl', 'dll', 'bat', 'cmd', 'ps1', 'psm1', 'vbs', 'vbe', 'js', 'jse', 'wsf', 'wsh', 'hta',
  'jar', 'lnk', 'reg', 'iso', 'img', 'vhd', 'vhdx', 'dmg', 'pkg', 'app', 'sh', 'apk',
  'zip', 'rar', '7z', 'tar', 'gz', 'tgz', 'bz2', 'xz', 'cab', 'arj', 'ace',
  'docm', 'dotm', 'xlsm', 'xltm', 'xlam', 'xlsb', 'pptm', 'potm', 'ppam', 'ppsm', 'sldm',
  'html', 'htm', 'xhtml', 'svg', 'mht', 'mhtml', 'xml', 'url', 'website', 'chm', 'one',
]);

export function isRiskyAttachment(filename: string): boolean {
  const parts = filename.toLowerCase().trim().split('.');
  if (parts.length < 2) return false;
  return RISKY_EXTENSIONS.has(parts[parts.length - 1]!);
}
